











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {AuditoriaObservacao} from '@/model/resource/AuditoriaObservacao'
import {AuditoriaObservacaoCollection} from '@/model/collection/AuditoriaObservacaoCollection'
import {ListAuditoriaObservacaoSchema} from '@/schema/resource/AuditoriaObservacao/ListAuditoriaObservacaoSchema'
import {CsvAuditoriaObservacaoSchema} from '@/schema/resource/AuditoriaObservacao/CsvAuditoriaObservacaoSchema'

@Component
export default class ListAuditoriaObservacaoView extends Mixins(
  MixinQueryRouter
) {
  schema = new ListAuditoriaObservacaoSchema()
  collection = new AuditoriaObservacaoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: AuditoriaObservacao) {
    Helper.pushByName('editAuditoriaObservacao', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new AuditoriaObservacaoCollection()
      .clearFilters()
      .addFilter(params)

    await csv.listCsvAuditoriaObservacao()
    new CsvAuditoriaObservacaoSchema().downloadCsv(csv.all())
  }
}
